import Environment from './environment'

export default class PeripheralBridge {

  static setupWebViewJavascriptBridge = (callback) => {
    if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge) }
    if (window.VNCallbacks) { return window.VNCallbacks.push(callback) }
    window.VNCallbacks = [callback]
    var VNIframe = document.createElement('iframe')
    VNIframe.style.display = 'none'
    VNIframe.src = 'vnscheme://__BRIDGE_LOADED__'
    document.documentElement.appendChild(VNIframe)
    setTimeout(function() { document.documentElement.removeChild(VNIframe) }, 0)
  }

  static getBridge() {
    if (!Environment.app.isProduction && window.WebViewJavascriptBridge !== undefined) {
      const registerHandlerMiddleware = (type, callback) => {
        window.WebViewJavascriptBridge.registerHandler(type, (data) => {
          console.log('%c ### registerHandler ###', 'font-size: 16px; color: orange;');
          console.log(type);
          console.log(data);
          callback(data)
        })
      }

      return {
        ...window.WebViewJavascriptBridge,
        registerHandler: registerHandlerMiddleware
      }
    }

    return window.WebViewJavascriptBridge
  }
}
